import { render, staticRenderFns } from "./BillApplyShipments.vue?vue&type=template&id=6669584f&scoped=true"
import script from "./BillApplyShipments.vue?vue&type=script&lang=js"
export * from "./BillApplyShipments.vue?vue&type=script&lang=js"
import style0 from "./BillApplyShipments.vue?vue&type=style&index=0&id=6669584f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6669584f",
  null
  
)

export default component.exports